import React, {Component} from 'react';
import {connect} from "react-redux";
import './Published.css';
import SearchRow from "../Search/SearchRow";
import { Link } from 'react-router-dom';
import $ from "jquery";
import {fetchCampaign} from "../../actions/campaignActions";

class Published extends Component {
    constructor(props) {
        super(props);
    };
    options = () => {
     if(this.props.delete){
            return(
                <React.Fragment>
                    <h4>{this.props.err_message ? this.props.err_message : 'Are you sure you want to delete this Jira Ticket?'}</h4>
                    <div className="published-footer">
                        {this.props.err_message ? (
                                <button className="button button--blue pub-btn" onClick={this.props.close}>Okay</button>)
                            : (    <React.Fragment>
                                <button className="button button--blue pub-btn" onClick={this.props.deleteJira}>Yes</button>
                                <button className="button button--red pub-btn" onClick={this.props.close}>No</button>
                            </React.Fragment>)
                        }
                    </div>
                </React.Fragment>
            )
        }else{
            return(
                <React.Fragment>
                    <h4>{this.props.message ? this.props.message : this.props.err_message}</h4>
                    {this.props.url ? <a href={this.props.url} target="_blank">{this.props.url}</a> : ""}
                    <div className="published-footer">
                        <button className="button button--blue pub-btn" onClick={this.props.close}>Okay</button>
                    </div>
                </React.Fragment>
            )
        }
    }
    campaign = () => {
        $("html, body").animate({scrollTop: 0}, 300);
        let epic = this.checkEpic(this.props.mockUnits);
        if(!epic.answer){
            if(epic.array.length > 0){
                let name = this.props.campaignName.name;
                if(this.props.message !== false){
                    return(
                        <React.Fragment>
                            <h4 className="text-campaign">{this.props.message ? this.props.message : ""}</h4>
                            {this.props.urls.length > 0 ? (
                                <ul id="mock-list">
                                    {this.props.urls.map((unit, key) => (
                                        <li key={key}> <a href={unit.url} target="_blank">{unit.jira_id + " - " + unit.creative_type + `${unit.media_label !== null ? " - " + unit.media_label : "" }`}</a></li>
                                    ))}
                                </ul>
                            ) : ""}
                            {this.props.jira_errs.length > 0 ? (
                                <div>
                                    {this.props.e_message ? (
                                        <h4 className="text-campaign">{this.props.e_message}</h4>
                                    ): (<h4 className="text-campaign">The following creatives failed to publish:</h4>)}
                                    <ul id="err-list">
                                        {this.props.jira_errs.map((e, key) => (
                                            <li key={key}> <a href={e.cl_link} target="_blank">{e.cl_link}</a></li>
                                        ))}
                                    </ul>
                                </div>
                            ): ""}
                            <div className="published-footer">
                                <button className="button button--blue pub-btn" onClick={() => {this.props.toggleModal('jira', false); this.props.dispatch(fetchCampaign(this.props.campaignName.id))}}>Okay</button>
                            </div>
                        </React.Fragment>
                    )
                }else {
                    return (
                        <React.Fragment>
                            <h4 className="text-campaign">The following creatives will be published:</h4>
                            <ul id="mock-list">
                                {epic.array.map((row, key) => (
                                    <li key={key}><Link to={`/mock/${row.id}`}
                                                        target="_blank">{name + " - " + row.creative_type}</Link></li>
                                ))}
                            </ul>
                            <p>Note: If a creative has already been published to JIRA or does not have a valid EPIC ID,
                                it will not appear in this list.</p>
                            <div className="published-footer">
                                <button className="button button--blue pub-btn"
                                        onClick={() => this.props.publishToJira()}>Publish
                                </button>
                                <button className="button button--red pub-btn"
                                        onClick={() => this.props.toggleModal('jira', false)}>Cancel
                                </button>
                            </div>
                        </React.Fragment>
                    )
                }
            }
            else{
                return(
                    <div className="published-footer">
                        <h4>All creatives for this campaign have already been published.</h4>
                        <button className="button button--blue pub-btn" onClick={()=>this.props.toggleModal('jira', false)}>Okay</button>
                    </div>
                )
            }
        }else{
            return(
                <div className="published-footer">
                    <h4>All creatives need a EPIC ID.</h4>
                    <button className="button button--blue pub-btn" onClick={()=>this.props.toggleModal('jira', false)}>Okay</button>
                </div>
            )
        }
    }
    checkEpic = (arr) => {
        let epic = arr.filter(mock => mock.EPIC_ID === null)
        let mockObj = {}
        if(epic.length === arr.length){
            mockObj = {
                answer: true,
                array: []
            }
          return mockObj;
        }else{
            mockObj = {
                answer: false,
                array: arr.filter(mock => mock.unit_type === "mock" && mock.published === "0" && mock.EPIC_ID !== null)
            }
            return mockObj;
        }
    }

    render() {
        return(
            <div className="modal-overlay">
                <div className="modal published_modal modal-function" id="published_modal">
                    <div className="modal-content ">
                        {this.props.campaign ? this.campaign() : this.options()}
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(null)(Published);
